module.exports = __webpack_public_path__ + "media/budgeting_calculators/background-m-f21a56b8.png";